import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoadingController } from '@ionic/angular';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    private loading?: HTMLIonLoadingElement;
    private createPromise: Promise<HTMLIonLoadingElement> | null = null;
    private presentPromise: Promise<void> | null = null;
    private refCount = 0;

    constructor(private loadingCtrl: LoadingController) {}

    // Create Loaader
    async create() {
        this.refCount += 1;

        if (!this.createPromise) {
            this.createPromise = this.loadingCtrl
                .create({ cssClass: 'loader' })
                .then((loader) => {
                    this.loading = loader;
                    return loader;
                })
                .catch((error) => {
                    this.createPromise = null;
                    throw error;
                });
        }

        const loader = await this.createPromise;

        if (this.refCount > 0 && !this.presentPromise) {
            this.presentPromise = loader
                .present()
                .catch(() => {})
                .finally(() => {
                    this.presentPromise = null;
                });
        }
    }

    async dismiss(force: boolean = false) {
        if (force) {
            this.refCount = 0;
        } else if (this.refCount > 0) {
            this.refCount -= 1;
        }

        if (this.refCount > 0) return;

        if (this.createPromise) {
            try {
                await this.createPromise;
            } catch {
                // ignore create errors when dismissing
            }
        }

        if (this.presentPromise) {
            try {
                await this.presentPromise;
            } catch {
                // ignore present errors when dismissing
            }
        }

        const top = await this.loadingCtrl.getTop();
        if (top) {
            try {
                await top.dismiss();
            } catch {
                // ignore dismiss errors
            }
        }

        this.loading = undefined;
        this.createPromise = null;
        this.presentPromise = null;
    }
}
